import { render, staticRenderFns } from "./RequisitosComplejidad.vue?vue&type=template&id=5a759956&"
import script from "./RequisitosComplejidad.vue?vue&type=script&lang=js&"
export * from "./RequisitosComplejidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports